// An email address, rendered as the address it is.
//
// The app's global stylesheet sets `button { text-transform: capitalize
// !important }`, which turned a real recipient into
// Staging_admin@Dental-Sem.Co.Uk — not a styling nit but a misrepresented
// address. An explicit declaration on the text's own element beats the
// inherited value whatever its importance, so this fixes the display without
// touching the global rule, whose blast radius is the whole app.
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

export default function EmailText({ children, variant = 'body2', sx = {}, ...rest }) {
    return (
        <Typography component="span" variant={variant} sx={{ textTransform: 'none', ...sx }} {...rest}>
            {children}
        </Typography>
    );
}

EmailText.propTypes = {
    children: PropTypes.node,
    variant: PropTypes.string,
    sx: PropTypes.object,
};
